import PlanQuotaPage from '@/views/profile/PlanQuotaPage'

export default function PlanQuotaScreen() {
  return <PlanQuotaPage />
}
